import { HelpItem } from "./helpApi.types";

const helpItems: HelpItem[] = [
  {
    title: 'Дорки',
    text: `Google Dorking, також відоме як Google hacking, — це техніка, яка використовується для пошуку конкретної інформації в Google за
    допомогою розширених операторів пошуку. Ці оператори дозволяють користувачам уточнити свої пошукові запити, щоб знайти
    специфічні дані, які можуть бути не так легко знайдені через звичайний пошук. Google Dorks можуть бути використані для виявлення
    вразливих серверів, помилок у конфігурації, чутливих документів, і навіть інформації про особу.`,
    anchor: 'dorks',
    childrens: [
      {
        title: 'Пошук в URL - inurl: exapple',
        text: 'Шукає слова, які містяться в URL. Наприклад, inurl:admin покаже сторінки, URL яких містить слово "admin".',
        anchor: 'inurl',
      },
      {
        title: 'Пошук в Title сторінки',
        text: `Оператор intitle використовується для пошуку веб-сторінок, заголовки яких містять певний текст. Це корисно, коли потрібно знайти сторінки, які спеціалізуються на конкретній темі.
        Приклад:
        "intitle:рецепти борщу" знайде сторінки, заголовки яких містять слово "рецепти" та "борщу".`,
        anchor: 'intitle',
      },
      {
        title: 'Пошук по конкретному сайту',
        text: `Оператор site використовується для обмеження пошуку інформацією, доступною лише на певному веб-сайті або домені.
        Приклад:
        site:example.com знайде сторінки лише з домену example.com.`,
        anchor: 'site',
      },
      {
        title: 'Пошук по файлам',
        text: `Оператор filetype використовується для пошуку файлів певного типу. Це корисно, коли шукаєте документи, презентації, PDF-файли тощо.
        Приклад:
        filetype:pdf знайде файли у форматі P`,
        anchor: 'filetype',
      },
    ],
  },
  {
    title: 'Параметри Url',
    text: ``,
    anchor: 'url-params',
    childrens: [
      {
        title: 'Мова інтерфейсу пошукової системи',
        text: `Визначає мову інтерфейсу користувача для сервісів Google. Це впливає на мову меню, кнопок, допомоги та інших елементів інтерфейсу, але не на мову вмісту пошукових результатів.
        Приклад: Щоб встановити мову інтерфейсу українською, параметр URL буде hl=uk. URL для пошуку Google з українською мовою інтерфейсу може виглядати так: https://www.google.com/search?hl=uk&q=Київ.`,
        anchor: 'hl',
      },
      {
        title: 'Локація результатів пошуку',
        text: `Вказує на країну, для якої повинні бути локалізовані пошукові результати. Цей параметр впливає на ранжування сайтів залежно від географічної релевантності. Наприклад, пошукові запити з параметром gl=us можуть показувати більше сайтів з США.
        Приклад: Для отримання результатів, оптимізованих для України, використовуйте gl=ua. URL приклад: https://www.google.com/search?hl=uk&gl=ua&q=Львів.`,
        anchor: 'gl',
      },
      {
        title: 'Мова контенту результатів пошуку',
        text: `Обмежує пошукові результати документами, написаними на певній мові. Використання цього параметра дозволяє отримати контент, який є найбільш релевантним до вибраної мови. Значення параметра lr починається з lang_, за яким слідує код мови.
        Приклад: Щоб обмежити пошук контентом українською мовою, використовуйте lr=lang_uk. Приклад URL, який шукає інформацію про каву, обмежену українською мовою: https://www.google.com/search?hl=uk&lr=lang_uk&q=кава.`,
        anchor: 'lr',
      },
      {
        title: 'Тип контенту',
        text: `Цей параметр використовується для вказівки на тип пошукового запиту, що дозволяє користувачам обмежити результати пошуку певним типом контенту, як-от зображення, відео, новини тощо. Приклади використання:
        tbm=isch — обмежує пошук зображеннями.
        tbm=nws — фільтрує результати до новин.
        tbm=vid — використовується для пошуку відео.
        tbm=shop — фільтрує результати для покупок або товарів.`,
        anchor: 'tbm',
      },
      {
        title: 'Часовий діапазон',
        text: `Цей параметр використовується для тонкої настройки результатів пошуку засновано на певному часовому діапазоні або інших критеріях часу. Він дозволяє користувачам знаходити контент, який був опублікований або оновлений протягом певного періоду часу.
        Приклади використання:
        tbs=qdr:h — показує результати, опубліковані протягом останньої години.
        tbs=qdr:d — фільтрує результати до тих, що були опубліковані протягом останнього дня.
        tbs=qdr:w — відображає контент, опублікований протягом останнього тижня.
        tbs=qdr:m — показує результати за останній місяць.
        tbs=qdr:y — фільтрує результати до тих, що були опубліковані протягом останнього року.
        tbs=cdr:1,cd_min:mm/dd/yyyy,cd_max:mm/dd/yyyy — для пошуку контенту між конкретними датами, де mm/dd/yyyy вказує на мінімальну та максимальну дати.`,
        anchor: 'tbs',
      },
    ],
  },
];

export default helpItems;
